module.exports = __webpack_public_path__ + "static/img/6.134408b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/sp/6.png
// module id = gaQp
// module chunks = 0